export type MessageSender = 'user' | 'bot' | 'other';
export type MessageKind = 'TEXT' | 'IMAGE';
export type MessageSemanticType =
  | 'AGENT_REPLY'
  | 'PAYMENT_STATUS'
  | 'PAYMENT_RETRY_REQUEST'
  | 'REPORT_REQUEST'
  | 'REPORT_STATUS';
export type ReportStatus = 'AVAILABLE' | 'CONFIRMED' | 'UNCONFIRMED' | 'COMPLETED' | 'FAILED';
export interface ReportSummary {
  vehicleLicensePlate: string;
  reportDate: string;
  totalTransactions: number;
  currency: string;
  totalAmount: number;
  paymentMethods: { category: string; totalTransactions: string; totalAmount: string }[];
}
export type MessageStatus = 'sending' | 'sent' | 'processing' | 'done' | 'failed';
export type ProcessingStatus = 'ACKNOWLEDGED' | 'PROCESSING';
export type PaymentRetryStatus = 'AVAILABLE' | 'CONFIRMED' | 'UNCONFIRMED';
export type ValidationStatus = 'PENDING' | 'OK' | 'REJECTED' | 'ERROR';
export type PaymentStatus =
  | 'VALIDATED'
  | 'DUPLICATED'
  | 'NOT_FOUND'
  | 'DATE_EXPIRED'
  | 'NON_PAYMENT_IMAGE'
  | 'CHANNEL_NOT_ALLOWED'
  | 'MANUAL_REVIEW_REQUIRED'
  | 'USER_CONFIRMATION_REQUIRED'
  | 'ERROR_AGENT'
  | 'ERROR_PROCESSOR';

export interface Message {
  id: string;
  chatId: string | number;
  userId: string;
  text: string;
  sender: MessageSender;
  createdAt?: number;
  kind?: MessageKind;
  semanticType?: MessageSemanticType | null;
  clientMessageId?: string;
  parentClientMessageId?: string;
  parentMessageId?: string;
  status?: MessageStatus;
  messageId?: string;
  mediaUrl?: string;
  localPreviewUrl?: string;
  remoteMediaUrl?: string;
  caption?: string;
  validation?: ValidationStatus | PaymentStatus;
  paymentStatus?: PaymentStatus;
  paymentRetryStatus?: PaymentRetryStatus;
  validationReason?: string;
  processingStatus?: ProcessingStatus;
  operationNumber?: string;
  currencyAmount?: string;
  validationDays?: number;
  paymentDate?: string;
  reportStatus?: ReportStatus;
  reportSummary?: ReportSummary;
  reportUrl?: string;
}

export interface ReportStatusUpdate {
  chatId: string | number;
  messageId: string;
  reportStatus: ReportStatus;
}

export interface ValidationUpdate {
  messageId?: string;
  clientMessageId?: string;
  parentMessageId?: string;
  createdAt?: number;
  status: ValidationStatus;
  paymentStatus?: PaymentStatus;
  reason?: string;
}

export const IMG_PREFIX = '__IMG__:';

export function isImageMessage(textOrMsg: string | Message | undefined): boolean {
  if (!textOrMsg) return false;
  if (typeof textOrMsg === 'string') return textOrMsg.startsWith(IMG_PREFIX);
  return textOrMsg.kind === 'IMAGE' || textOrMsg.text.startsWith(IMG_PREFIX);
}

export function getImageUrl(textOrMsg: string | Message | undefined): string {
  if (!textOrMsg) return '';
  if (typeof textOrMsg === 'string') {
    return textOrMsg.startsWith(IMG_PREFIX) ? textOrMsg.slice(IMG_PREFIX.length) : '';
  }
  if (textOrMsg.mediaUrl) return textOrMsg.mediaUrl;
  if (textOrMsg.text.startsWith(IMG_PREFIX)) return textOrMsg.text.slice(IMG_PREFIX.length);
  return '';
}
